import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import RegisterForm from './routes/Register'
import ResetPassword from './routes/ResetPassword';
import ForgotPassword from './routes/ForgotPassword';
import ChangePassword from './routes/ChangePassword';
import Logout from './routes/Logout';
import MobileOTP from './routes/MobileOTP';
import { createTheme, ThemeProvider } from '@mui/material';
import EmailOTP from './routes/EmailOTP';
import ChangeDetails from './routes/ChangeDetails';

const theme = createTheme({
  palette: {
    primary: {
      main: '#EC1C24'
    },
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="register" element={<RegisterForm />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="reset-password" element={<ResetPassword />} />
          <Route path="change-password" element={<ChangePassword />} />
          <Route path="logout" element={<Logout />} />
          <Route path="verify-phone" element={<MobileOTP />} />
          <Route path="verify-email" element={<EmailOTP />} />
          <Route path="change-details" element={<ChangeDetails />} />
        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
